import { render, staticRenderFns } from "./VuesticIconSlower.vue?vue&type=template&id=4b111080"
import script from "./VuesticIconSlower.vue?vue&type=script&lang=js"
export * from "./VuesticIconSlower.vue?vue&type=script&lang=js"
import style0 from "./VuesticIconSlower.vue?vue&type=style&index=0&id=4b111080&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports